import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('appmodules/list', { params });
  },
  async add(params: any) {
    return axios.post('appmodules/add', qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post('appmodules/edit', qs.stringify(params));
  },
  async detail(params: any) {
    return axios.get('appmodules/detail', { params });
  },
  async delete(params: any) {
    return axios.post('appmodules/delete', qs.stringify(params));
  },
  async options(params: any) {
    return axios.get('appmodules/options', { params });
  },
  async saveoptions(params: any) {
    return axios.post('appmodules/saveoptions', qs.stringify(params));
  }
};
